// import wx from './lib/jweixin-1.4.0';
import { $Jsonp } from './lib/request';
import FxAjax from "@fx/ajax";
/**
 * ============================================================================
 * 微信环境初始化
 * ============================================================================
 */
var wxEnvir = (function () {
    if (!window.kgWxEnvir) {
        window.kgWxEnvir = new KGWxEnvir();
    }

    function init(cb) {
        window.kgWxEnvir.init(cb);
    }

    function share(shareData) {
        window.kgWxEnvir.share(shareData);
    }

    function getUserInfo() {
        function getWxLoginUrl() {
            var url = window.location.href;
            var redirect_uri = encodeURIComponent("https://mwechats.kugou.com/service/user/getInfo?redirect_uri=" + encodeURIComponent(url));
            return "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx412c15698d95020e&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect";
        }

        if ((/MicroMessenger/i).test(navigator.userAgent)) {
            var search = decodeURIComponent(window.location.search), searchP;
            if (search.indexOf("openid") != -1 && search.indexOf("unionid") != -1) {
                var userInfo = {
                    openid: "",
                    unionid: "",
                    nickname: "",
                    sex: "",
                    city: "",
                    province: "",
                    country: "",
                    headimgurl: "",
                }
                search = search.substr(1).split("&");
                for (var i = 0; i < search.length; i++) {
                    searchP = search[i];
                    if (searchP.indexOf("openid") != -1) {
                        searchP = searchP.substring(searchP.indexOf("openid"));
                    }
                    searchP = searchP.split("=")
                    if (searchP.length > 1) {
                        if (userInfo[searchP[0]] != undefined) {
                            userInfo[searchP[0]] = searchP[1];
                        }
                    }
                }
                return userInfo;
            } else {
                //重定向
                window.location.href = getWxLoginUrl();
                return undefined;
            }
        }

        return null;
    }

    //微信初始化对象
    function KGWxEnvir() {
        //新增新、旧两种分享方式, add by sunzhang at 2020.2.11
        var domain_old = ["m3ws.kugou.com", "ep.kugou.com", "activity.kugou.com"];
        var domain_new = ["m3ws.kugou.com", "h5.kugou.com", "mtpls.kugou.com"];

        var host = window.location.host;
        if (domain_old.join(",").indexOf(host) != -1) {
            //走原来的分享流程
            this.useNewShare = false;
        } else if (domain_new.join(",").indexOf(host) != -1) {
            //走新的分享流程
            this.useNewShare = true;
        } else {
            //域名都未命中，还是走原来的分享流程
            this.useNewShare = false;
        }


        this.hasCheck = false;     //开始获取微信参数
        this.hasRegister = false;  //是否初始化
        this.hasReady = false;     //微信环境准备完成
        if (window.location.origin.indexOf("kugou.com") != -1) {
            this.this_url = encodeURIComponent(window.location.href);
        } else {
            this.this_url = encodeURIComponent('http://kugou.com');
        }
        this.cbBus = [];     //回调函数站
    }

    KGWxEnvir.prototype.init = function (cb) {
        var _this = this;
        _this.loadWxJs(function () {
            if (_this.hasReady) {
                cb && cb(window.wx);
            } else {
                if ((/MicroMessenger/i).test(navigator.userAgent)) {
                    _this.cbBus.push(cb);
                    if (_this.hasCheck) {
                        return;
                    }

                    _this.hasCheck = true;
                    _this.getSignature();
                }
            }
        })
    }

    KGWxEnvir.prototype.loadWxJs = function (fn) {
        if (window.wx) {
            fn && fn();
        } else {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            if (script.readyState) {
                script.onreadystatechange = function () {
                    if (script.readyState == 'loaded' || script.readyState == 'complete') {
                        script.onreadystatechange = null;
                        fn && fn();
                    }
                };
            } else {
                //其他浏览器
                script.onload = function () {
                    fn && fn();
                };
            }

            script.src = "https://staticssl.kugou.com/common/js/kg-jweixin-1.4.0.js";
            document.getElementsByTagName('head')[0].appendChild(script);
        }
    }

    KGWxEnvir.prototype.getSignature = function () {
        var _this = this;
        // 修改
        function fxFetch(url, config) {
            return new Promise((resolve, reject) => {
                FxAjax({
                    ...config,
                    url,
                    type: config.method || "GET",
                    data: config.body,
                    headers: config.headers,
                    timeout: config.timeout,
                    success: json => resolve({ json: () => json }),
                    error: (xhr, type) => reject(type)
                });
            });
        };
        function getWXConfig(url, callback) {
            const WX_CONFIG_URL = "https://fx.service.kugou.com/m/weixinSign";
            fxFetch(WX_CONFIG_URL, {
                method: "POST",
                body: `url=${encodeURIComponent(url.replace(/#.+/, ""))}`,
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                timeout: 2000
            }).then(res => res.json()).then(json => {
                if (json.status == 1) {
                    callback && callback(json.data)
                }
            })
        };

        if (!_this.useNewShare) {
            getWXConfig(decodeURIComponent(_this.this_url), function (callbackData) {
                // $Jsonp({
                //     url: 'https://mwechats.kugou.com/jssdk/getSignature?caller=kugou_mobile&url=' + _this.this_url,
                //     success: function (callbackData) {
                if (callbackData) {

                    /*微信分享设置*/
                    window.wx.config({
                        debug: false,
                        beta: true,
                        appId: callbackData.appId,
                        timestamp: callbackData.timestamp,
                        nonceStr: callbackData.nonceStr,
                        signature: callbackData.signature,
                        jsApiList: [
                            'launchApplication', // 打开第三方app
                            "onMenuShareTimeline", // 分享朋友圈
                            "onMenuShareAppMessage", // 分享给朋友
                            "onMenuShareQQ", // 分享到QQ
                            "onMenuShareWeibo", // 分享到腾讯微博
                            "onMenuShareQZone", // 分享到QQ空间
                        ]
                    });
                    _this.hasRegister = true;
                    setTimeout(function(){
                        window.wx.ready(function () {
                            _this.hasReady = true;
                            _this.cbBus.forEach(function (cb) {
                                cb && cb(window.wx);
                            })
                        })
                    }, 100)

                }
                // }
                // })
            })
        } else {
            getWXConfig(decodeURIComponent(_this.this_url), function (callbackData) {
                // $Jsonp({
                //     url: 'https://mwechats.kugou.com/service/jssdk/getSignature?caller=kugou_web&url=' + _this.this_url,
                //     success: function (callbackData) {
                // console.log('getSignature res', callbackData);
                if (callbackData) {
                    window.wx.config({
                        beta: true,
                        debug: false, //调试时改为true
                        appId: callbackData.appId,
                        timestamp: callbackData.timestamp,
                        nonceStr: callbackData.nonceStr,
                        signature: callbackData.signature,
                        jsApiList: [
                            'launchApplication', // 打开第三方app
                            'updateAppMessageShareData',
                            'updateTimelineShareData',
                            'onMenuShareTimeline',
                            'onMenuShareAppMessage',
                            'onMenuShareQQ',
                            'onMenuShareWeibo',
                            'onMenuShareQZone'
                        ]
                    })
                    _this.hasRegister = true;
                    setTimeout(function(){
                        window.wx.ready(function () {
                            _this.hasReady = true;
                            _this.cbBus.forEach(function (cb) {
                                cb && cb(window.wx);
                            })
                        })
                    }, 100)

                }
                //     }
                // })
            })
        }
    }

    KGWxEnvir.prototype.share = function (shareData) {
        if (!this.hasRegister) {
            return "还未完成初始化，请在init回调中调用share方法";
        }

        window.wx.ready(function () {
            //分享给朋友
            window.wx.onMenuShareAppMessage({
                title: shareData.title,
                desc: shareData.content,
                link: shareData.url,
                imgUrl: shareData.img,
                trigger: function (res) {
                },
                success: function (res) {
                },
                cancel: function (res) {
                },
                fail: function (res) {
                }
            });
            //分享朋友圈
            window.wx.onMenuShareTimeline({
                title: shareData.title,
                desc: shareData.content,
                link: shareData.url,
                imgUrl: shareData.img,
                trigger: function (res) {
                },
                success: function (res) {
                },
                cancel: function (res) {
                },
                fail: function (res) {
                }
            });
            window.wx.onMenuShareQQ({
                title: shareData.title, // 分享标题
                desc: shareData.content, // 分享描述
                link: shareData.url, // 分享链接
                imgUrl: shareData.img, // 分享图标
                success: function () {
                },
                cancel: function () {
                }
            });
            window.wx.onMenuShareQZone({
                title: shareData.title, // 分享标题
                desc: shareData.content, // 分享描述
                link: shareData.url, // 分享链接
                imgUrl: shareData.img, // 分享图标
                success: function () {
                },
                cancel: function () {
                }
            });
            window.wx.onMenuShareWeibo({
                title: shareData.title, // 分享标题
                desc: shareData.content, // 分享描述
                link: shareData.url, // 分享链接
                imgUrl: shareData.img, // 分享图标
                success: function () {
                },
                cancel: function () {
                }
            });
        })
    }

    return {
        init: init,
        share: share,
        getUserInfo: getUserInfo
    }

}());

export default wxEnvir;